import { useAddToPortfolioContext } from '@/components/portfolio/add-to-portfolio/AddToPortfolioProvider';
import type { FundRawRecord } from '@/components/funds-raw/types';

export function useAddToPortfolio() {
  const { open, close } = useAddToPortfolioContext();
  type FundsRawOpts = { fund?: FundRawRecord | null; funds?: FundRawRecord[]; onSuccess?: () => void };
  return {
    open,
    close,
    openFundsRaw: (opts: FundsRawOpts) =>
      open({ type: 'funds_raw', fund: opts.fund ?? null, funds: opts.funds, onSuccess: opts.onSuccess }),
  } as const;
}
